import fileDownload from 'js-file-download';

const CSV_MIME_TYPE = 'text/csv;charset=utf-8';

// Task 15590: Excel on Windows opens a CSV that has no byte-order mark in the ANSI code page, so "ä" showed as "Ã¤"
// and a non-breaking space as "Â ". The browser decodes the server's response to a string (dropping any mark the
// server could send) and js-file-download re-encodes that string as UTF-8, so the mark has to be added here, where
// the bytes of the saved file are produced.
const UTF8_BYTE_ORDER_MARK = '\uFEFF';

export function downloadCsv(content: string, fileName: string): void {
    fileDownload(content, fileName, CSV_MIME_TYPE, UTF8_BYTE_ORDER_MARK);
}
